import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const ModernAdminSidebar = ({ collapsed, mobileOpen, onMobileToggle }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const location = useLocation();

  const toggleExpanded = (itemKey) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemKey]: !prev[itemKey]
    }));
  };

  const menuItems = [
    {
      key: 'dashboard',
      title: 'Dashboard',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5a2 2 0 012-2h4a2 2 0 012 2v3H8V5z" />
        </svg>
      ),
      href: '/admin'
    },
    {
      key: 'products',
      title: 'Produits',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      subItems: [
        { title: 'Tous les produits', href: '/admin/products' },
        { title: 'Ajouter un produit', href: '/admin/products/add' },
        { title: 'Catégories', href: '/admin/categories' },
        { title: 'Promotions', href: '/admin/promotions' },
        { title: 'Bannières', href: '/admin/banners' }
      ]
    },
    {
      key: 'orders',
      title: 'Commandes',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      ),
      subItems: [
        { title: 'Toutes les commandes', href: '/admin/orders' },
        { title: 'En attente', href: '/admin/orders/pending' },
        { title: 'Confirmées', href: '/admin/orders/confirmed' },
        { title: 'En traitement', href: '/admin/orders/processing' },
        { title: 'Expédiées', href: '/admin/orders/shipped' },
        { title: 'Livrées', href: '/admin/orders/delivered' },
        { title: 'Annulées', href: '/admin/orders/cancelled' }
      ]
    },
    {
      key: 'users',
      title: 'Utilisateurs',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
        </svg>
      ),
      subItems: [
        { title: 'Tous les utilisateurs', href: '/admin/users' },
        { title: 'Acheteurs', href: '/admin/users/buyers' }
      ]
    },
    {
      key: 'suppliers',
      title: 'Fournisseurs',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      href: '/admin/suppliers'
    },
    {
      key: 'delivery',
      title: 'Livreurs',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      href: '/admin/delivery'
    },
    {
      key: 'reports',
      title: 'Rapports',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      href: '/admin/reports'
    },
    {
      key: 'settings',
      title: 'Paramètres',
      icon: (
        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      href: '/admin/settings'
    }
  ];

  const isActive = (href) => {
    if (href === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      {/* Header */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          🌱
        </div>
        <div className="sidebar-title">
          Dikass
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-section-title">Principal</div>
          {menuItems.slice(0, 1).map((item) => (
            <div key={item.key} className="nav-item">
              <NavLink
                to={item.href}
                className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
                onClick={() => onMobileToggle()}
              >
                {item.icon}
                <span className="nav-text">{item.title}</span>
              </NavLink>
            </div>
          ))}
        </div>

        <div className="nav-section">
          <div className="nav-section-title">Gestion</div>
          {menuItems.slice(1, 4).map((item) => (
            <div key={item.key} className={`nav-item ${expandedItems[item.key] ? 'expanded' : ''}`}>
              <button
                className={`nav-link ${item.subItems?.some(sub => isActive(sub.href)) ? 'active' : ''}`}
                onClick={() => toggleExpanded(item.key)}
              >
                {item.icon}
                <span className="nav-text">{item.title}</span>
                {item.subItems && (
                  <svg className="nav-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                )}
              </button>
              {item.subItems && (
                <div className="sub-nav">
                  {item.subItems.map((subItem, index) => (
                    <NavLink
                      key={index}
                      to={subItem.href}
                      className={`sub-nav-link ${isActive(subItem.href) ? 'active' : ''}`}
                      onClick={() => onMobileToggle()}
                    >
                      {subItem.title}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="nav-section">
          <div className="nav-section-title">Outils</div>
          {menuItems.slice(4).map((item) => (
            <div key={item.key} className="nav-item">
              <NavLink
                to={item.href}
                className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
                onClick={() => onMobileToggle()}
              >
                {item.icon}
                <span className="nav-text">{item.title}</span>
              </NavLink>
            </div>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default ModernAdminSidebar;
